<template>
  <div class="ele-body">
    <el-card shadow="never">
      <el-form :model="where" label-width="90px" class="ele-form-search"
        @keyup.enter.native="reload" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :lg="6" :md="12">
            <el-form-item label="国家/地区">
              <el-input clearable v-model.trim="where.country" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="币种名称">
              <el-input clearable v-model.trim="where.cny_name" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <el-form-item label="币种代码">
              <el-input clearable v-model.trim="where.cny_enname" placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="6" :md="12">
            <div class="ele-form-actions">
              <el-button type="primary" icon="el-icon-search" class="ele-btn-icon" @click="reload">查询</el-button>
              <el-button @click="reset">重置</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
      <ele-pro-table ref="table" :where="where" :datasource="url" :columns="columns"
        :selection.sync="selection" height="calc(100vh - 315px)">
        <template slot="toolbar">
          <el-button size="small" type="primary" icon="el-icon-plus" class="ele-btn-icon" @click="openEdit(null)"
            v-if="permission.includes('sys:currency:add')">添加</el-button>
          <el-button size="small" type="danger" icon="el-icon-delete" class="ele-btn-icon"
            :disabled="!selection.length" @click="removeBatch"
            v-if="permission.includes('sys:currency:dall')">删除</el-button>
        </template>
        <template slot="action" slot-scope="{ row }">
          <el-button size="small" type="primary" class="ele-btn-icon" @click="openEdit(row)"
            v-if="permission.includes('sys:currency:edit')">编辑</el-button>
          <el-popconfirm class="ele-action" title="确定删除吗？" @confirm="remove(row)"
            v-if="permission.includes('sys:currency:delete')">
            <el-button slot="reference" size="small" type="danger" class="ele-btn-icon">删除</el-button>
          </el-popconfirm>
        </template>
      </ele-pro-table>
    </el-card>
    <el-dialog :title="current && current.id ? '编辑货币' : '添加货币'" :visible.sync="showEdit"
      width="520px" :destroy-on-close="true" @closed="form = {}">
      <el-form :model="form" label-width="100px">
        <el-form-item label="国家/地区"><el-input v-model.trim="form.country" /></el-form-item>
        <el-form-item label="国家英文"><el-input v-model.trim="form.country_en" /></el-form-item>
        <el-form-item label="币种名称"><el-input v-model.trim="form.cny_name" /></el-form-item>
        <el-form-item label="币种代码"><el-input v-model.trim="form.cny_enname" /></el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="showEdit = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="save">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'WalletCurrency',
  computed: {
    ...mapGetters(['permission'])
  },
  data() {
    return {
      url: '/currency/index',
      columns: [
        { columnKey: 'selection', type: 'selection', width: 45, align: 'center', fixed: 'left' },
        { prop: 'id', label: '序号', width: 60, align: 'center' },
        { prop: 'country', label: '国家/地区', minWidth: 120, align: 'center', showOverflowTooltip: true },
        { prop: 'country_en', label: '国家英文', minWidth: 120, align: 'center', showOverflowTooltip: true },
        { prop: 'cny_name', label: '币种名称', minWidth: 120, align: 'center', showOverflowTooltip: true },
        { prop: 'cny_enname', label: '币种代码', minWidth: 100, align: 'center', showOverflowTooltip: true },
        { columnKey: 'action', label: '操作', width: 160, align: 'center', slot: 'action', fixed: 'right' }
      ],
      where: {},
      selection: [],
      current: null,
      showEdit: false,
      form: {},
      saving: false
    };
  },
  methods: {
    reload() { this.$refs.table.reload({ where: this.where }); },
    reset() { this.where = {}; this.reload(); },
    openEdit(row) { this.current = row; this.form = row ? { ...row } : {}; this.showEdit = true; },
    save() {
      this.saving = true;
      this.$http.post('/currency/edit', this.form).then((res) => {
        if (res.data.code === 0) { this.$message.success(res.data.msg || '保存成功'); this.showEdit = false; this.reload(); }
        else { this.$message.error(res.data.msg || '保存失败'); }
      }).finally(() => { this.saving = false; });
    },
    remove(row) {
      this.$http.post('/currency/delete', { id: row.id }).then((res) => {
        if (res.data.code === 0) { this.$message.success(res.data.msg || '删除成功'); this.reload(); }
        else { this.$message.error(res.data.msg || '删除失败'); }
      });
    },
    removeBatch() {
      this.$http.post('/currency/dall', { id: this.selection.map((i) => i.id) }).then((res) => {
        if (res.data.code === 0) { this.$message.success(res.data.msg || '删除成功'); this.reload(); }
        else { this.$message.error(res.data.msg || '删除失败'); }
      });
    }
  }
};
</script>
